import styled from "styled-components";
import { Flex } from "@evergis/ui";

export const PaginationOption = styled(Flex)`
  font-size: 0.875rem;
`;

export const PaginationNumber = styled.div`
  margin-right: 1rem;
  color: ${({ theme: { palette } }) => palette.textSecondary};
`;
